import axios from "axios";
import { Urls } from "../../../store/urls";
import { ServiceUrls } from "../../serviceUrls";

export const DomainCmsListRepo = (params) => {
  return axios({
    method: "GET",
    url: Urls.GET_CMS_DOMAIN_LIST,
    params: params,
  });
};
export const postDomainCmsListRepo = (data) => {
  return axios({
    method: "POST",
    url: Urls.GET_CMS_DOMAIN_LIST,
    data: data
  });
};
export const deleteDomainCmsRepo = (params) => {
  return axios({
    method: "DELETE",
    url: Urls.GET_CMS_DOMAIN_LIST + `/${params?.id}`
  });
};
export const getDomainCmsRepo = (params) => {
  return axios({
    method: "Get",
    url: Urls.GET_CMS_DOMAIN_LIST + `/${params?.id}`
  });
};
export const putDomainCmsRepo = (params) => {
  return axios({
    method: "PUT",
    url: Urls.GET_CMS_DOMAIN_LIST + `/${params?.id}`,
    data:params
  });
};